import {useQueryParams} from '@aboutyou/router';
import {useEffect, useRef} from 'react';
import {useNewsLetterSignUpStateManager} from '../../backend-services/NotificationCenter/useNewsLetterSignUpStateManager';
import {useWalletStateManager} from '../../backend-services/Wallet/utils/useWalletStateManager';
import {AuthSearchParams} from '../Authentication/hooks/useAuthenticationOpenState';
import {useIsAuthenticated} from '../Authentication/hooks/useIsAuthenticated';

export enum DEEP_LINKS {
  cw = 'cw',
  newsletterSubscription = 'newsletterSubscription',
}

export const useDeepLinkOpener = () => {
  const queryParams = useQueryParams();
  const {isAuthenticated} = useIsAuthenticated();
  const {open: openWallet} = useWalletStateManager();
  const {open: openNewsletterSubscription} = useNewsLetterSignUpStateManager();
  const wasWalletOpen = useRef(false);

  // eslint-disable-next-line local-rules/prefer-use-query-params-callback
  useEffect(() => {
    if (queryParams.get(DEEP_LINKS.cw) !== 'true') {
      return;
    }

    if (wasWalletOpen.current) {
      return;
    }

    if (
      queryParams.get(AuthSearchParams.LoginReason) !== 'coupon' ||
      isAuthenticated
    ) {
      openWallet('coupons');
      wasWalletOpen.current = true;
    }
  }, [queryParams]);

  // eslint-disable-next-line local-rules/prefer-use-query-params-callback
  useEffect(() => {
    if (queryParams.get(DEEP_LINKS.newsletterSubscription)) {
      openNewsletterSubscription();
    }
  }, []);
};
